import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { images } from '../../data/images';
export function CreditCta() {
  return <section className="container-x py-16" aria-labelledby="credit-cta-title" data-id="element-629" data-mp="1fifmnw1ee3up">
      <div className="grid overflow-hidden rounded-3xl border border-neon/30 bg-surface lg:grid-cols-2" data-id="element-630" data-mp="1fgb7ghy1tif4">
        <div className="p-7 sm:p-12" data-id="element-631" data-mp="1jhohz5c369sd">
          <h2 id="credit-cta-title" className="font-display text-3xl font-black leading-[1.02] tracking-tight sm:text-5xl" data-id="element-632" data-mp="mujhs41od5mu">
            CONOCÉ TUS ALTERNATIVAS PARA LLEGAR A TU <span className="text-neon" data-id="element-633" data-mp="vugbwl6u2wpa">0 KM.</span>
          </h2>
          <p className="mt-5 max-w-md text-mist" data-id="element-634" data-mp="vsvjp27zrpul">
            Contanos tu anticipo disponible y tu situación laboral. Un asesor revisa tu caso y te propone las opciones de financiación que mejor se ajustan.
          </p>
          <ul className="mt-6 space-y-2 text-sm text-mist" data-id="element-635" data-mp="4162t8ecx9sv">
            <li data-id="element-636" data-mp="83jaw3gktjst">Te pedimos sólo los datos estrictamente necesarios.</li>
            <li data-id="element-637" data-mp="2i2pvu5h3zy2b">Seguís el estado de tu consulta con un número de seguimiento.</li>
            <li data-id="element-638" data-mp="2d34w3su47loj">No es una precalificación ni implica aprobación garantizada.</li>
          </ul>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row" data-id="element-639" data-mp="28cetuogzjyy2">
            <Link to="/chequeo" className="btn btn-credit h-12 px-6" data-id="element-640" data-mp="28ak6z4m5lwrc">
              Iniciar evaluación preliminar
              <ArrowRightIcon className="h-4 w-4" aria-hidden data-id="element-641" data-mp="23b7kikz72rpa" />
            </Link>
          </div>
        </div>
        <img src={images.interior} alt="Interior de un vehículo 0 km" className="h-64 w-full object-cover lg:h-full" loading="lazy" data-id="element-642" data-mp="1ybw3rbytvm7p" />
      </div>
    </section>;
}